import { render, staticRenderFns } from "./BoosterClub.vue?vue&type=template&id=c78a901a&scoped=true&"
import script from "./BoosterClub.vue?vue&type=script&lang=js&"
export * from "./BoosterClub.vue?vue&type=script&lang=js&"
import style0 from "./BoosterClub.vue?vue&type=style&index=0&id=c78a901a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c78a901a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VContainer,VImg})
